import React from 'react';
import {Banner} from "../../widgets/banner";
import {Information} from "../../widgets/information";
import {Projects} from "../../widgets/projects";
import {Industries} from "../../widgets/Industries";
import {Expertise} from "../../widgets/expertise";
import {RequestForm} from "../../widgets/request-form";

export const Main = () => {
  return (
    <>
      <Banner />
      <Information />
      <Projects />
      <Industries />
      <Expertise/>
      <RequestForm />
    </>
  );
}